import {
  Modal,
  Typography,
  Button,
  Select,
  InputLabel,
  FormControl,
  Box,
  MenuItem,
  IconButton,
  Tooltip,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import {
  useDeleteValoration,
  useValoration,
} from "../../../hooks/tableNotes/useValoration";
import DeleteIcon from "@mui/icons-material/Delete";

export const ValorationModal = ({ open, close, token, refresh, note }) => {
  const { valoration, setValoration, sendValoration } = useValoration({
    token,
    refresh,
  });
  const { deleteValoration } = useDeleteValoration({ token, refresh });

  const menuList = [
    { id: 1, name: "Positiva", value: "POSITIVA" },
    { id: 2, name: "Negativa", value: "NEGATIVA" },
    { id: 3, name: "Neutra", value: "NEUTRA" },
  ];

  const dataForm = note
    ? {
        id_sintesis: note.id_sintesis,
        valoracion: valoration,
        id: note.id_valoracion,
        cvcapsula: note.cvcapsula,
      }
    : {};

  return (
    <Modal
      open={open}
      onClose={close}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 5,
          borderRadius: "12px",
        }}
      >
        <IconButton
          onClick={close}
          style={{ position: "absolute", top: "10px", right: "10px" }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          id="modal-title"
          variant="h6"
          component="h2"
          style={{ marginTop: "20px" }}
        >
          {note?.valoracion === "Sin Valorar" ? "Añadir" : "Editar"} valoración
        </Typography>
        <FormControl fullWidth sx={{ mb: 4 }} style={{ marginTop: "40px" }}>
          <InputLabel id="select-label">Valoración</InputLabel>
          <Select
            labelId="select-label"
            value={
              valoration ||
              (note?.valoracion === "Sin Valorar" ? "" : note?.valoracion || "")
            }
            label="Seleccionar opción"
            onChange={(e) => setValoration(e.target.value)}
          >
            {menuList.map((item) => (
              <MenuItem key={item.id} value={item.value}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <div style={{ display: "flex" }}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ borderRadius: "4px", height: "40px", marginRight: "10px" }}
            onClick={() => {
              sendValoration(dataForm);
              close();
            }}
          >
            Guardar
          </Button>
          <Tooltip title="Eliminar valoración">
            <span>
              <IconButton
                color="primary"
                disabled={note?.valoracion === "Sin Valorar"}
                onClick={() => {
                  deleteValoration(note?.id_valoracion);
                  close();
                }}
              >
                <DeleteIcon />
              </IconButton>
            </span>
          </Tooltip>
        </div>
      </Box>
    </Modal>
  );
};
